


// import React, { useEffect, useState } from 'react';
// import { useHistory } from 'react-router-dom';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { MdOutlineModeEdit, MdCheck, MdVerifiedUser, MdOutlineChevronRight, MdCameraAlt } from 'react-icons/md';
// import { FiPhone, FiMail, FiLogOut, FiShield, FiSettings, FiBriefcase } from 'react-icons/fi';
// import { FaTrophy, FaGamepad, FaCrown, FaStar } from 'react-icons/fa';

// // Components & Socket
// import socket from '../Components/socket';
// import Header from '../Components/Header';
// import Rightcontainer from '../Components/Rightcontainer';

// const Profile1 = () => {
//   const [profile, setProfile] = useState();
//   const [total, setTotal] = useState(0);
//   const [isNameEdit, setIsNameEdit] = useState(false);
//   const [editedName, setEditedName] = useState("");
//   const history = useHistory();

//   // --- Premium Classic Light Palette ---
//   const THEME = {
//     bg: '#F8FAFC',
//     card: '#FFFFFF',
//     primary: '#475569', 
//     accentBlue: '#E0F2FE',
//     accentGold: '#FEF3C7',
//     accentGreen: '#DCFCE7',
//     textMain: '#1E293B',
//     border: '#E2E8F0'
//   };

//   const TotalGame = (Id) => {
//     let access_token = localStorage.getItem('token');
//     const headers = { Authorization: `Bearer ${access_token}` };
//     axios.get(`https://api.kakaking.in/total/user/all/${Id}`, { headers })
//       .then((res) => setTotal(res.data))
//       .catch((e) => console.error(e));
//   };

//   useEffect(() => {
//     if (profile?.Name) {
//       setEditedName(profile.Name);
//     }
//   }, [profile]);

//   const UserALL = () => {
//     let access_token = localStorage.getItem('token');
//     const headers = { Authorization: `Bearer ${access_token}` };
//     axios.get(`https://api.kakaking.in/me`, { headers })
//       .then((res) => {
//         setProfile(res.data);
//         TotalGame(res.data._id);
//       })
//       .catch((e) => console.error(e));
//   };

//   useEffect(() => {
//     socket.on('setProfile', (data) => {
//       setProfile(data);
//       TotalGame(data._id);
//     });
//     UserALL();
//   }, []);

//   const logout = () => {
//     let access_token = localStorage.getItem('token');
//     const headers = { Authorization: `Bearer ${access_token}` };
//     axios.post(`https://api.kakaking.in/logout`, {}, { headers })
//       .then(() => {
//         localStorage.removeItem('token');
//         history.push('/login');
//         window.location.reload(true);
//       });
//   };

//   const handleAvatarUpload = async (file) => {
//     if (file) {
//       const access_token = localStorage.getItem('token');
//       const formData = new FormData();
//       formData.append('avatar', file);
//       await fetch(`https://api.kakaking.in/users/me/avatar`, {
//         method: 'POST',
//         body: formData,
//         headers: { Authorization: `Bearer ${access_token}` },
//       });
//       UserALL();
//     }
//   };

//   const UpdateProfile = async () => {
//     if (!editedName.trim()) {
//       Swal.fire("Error", "Name cannot be empty", "error");
//       return;
//     }
//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.patch(
//         "https://api.kakaking.in/user/edit",
//         { Name: editedName.trim() },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (res.data === "User name already exist!") {
//         Swal.fire("Error", res.data, "error");
//         return;
//       }
//       setProfile((prev) => ({ ...prev, Name: res.data.Name }));
//       setIsNameEdit(false);
//       Swal.fire({ icon: "success", title: "Updated", timer: 1200, showConfirmButton: false });
//     } catch {
//       Swal.fire("Error", "Update failed", "error");
//     }
//   };

//   return (
//     <>
//       <Header user={profile} />
//       <div className='leftContainer' style={{ minHeight: '100vh', background: THEME.bg, paddingBottom: '120px' ,marginTop:"70px" }}>
//         <div className='pt-4 Orher_page_main_section'>

//           {/* --- PROFILE HEADER CARD --- */}
//           <div className="px-3">
//             <div className="classic-profile-card">
//               <div className="card-pattern"></div>
              
//               <div className="d-flex align-items-center justify-content-between px-3 mb-4">
//                  <div className="vip-badge"><FaStar className="mr-1" /> Elite Player</div>
//                  <FiSettings className="text-muted cursor-pointer" size={20} />
//               </div>

//               <div className="d-flex flex-column align-items-center">
//                 <div className="avatar-frame">
//                    <FaCrown className="classic-crown" />
//                   <label className="m-0 cursor-pointer">
//                     <img
//                       src={"/images/avatars/Avatar1.png"}
//                       alt="Profile"
//                       className="avatar-img-classic"
//                     />
//                     <div className="edit-badge-classic"><MdCameraAlt /></div>
//                     <input type="file" className="d-none" accept="image/*" onChange={(e) => handleAvatarUpload(e.target.files[0])} />
//                   </label>
//                 </div>

//                 <div className="mt-3 text-center">
//                   {!isNameEdit ? (
//                     <h3 className="classic-name">
//                       {profile?.Name || "Player"}
//                       <MdOutlineModeEdit className="ml-2 edit-pen" onClick={() => setIsNameEdit(true)} />
//                     </h3>
//                   ) : (
//                     <div className="classic-edit-input">
//                       <input
//                         value={editedName}
//                         onChange={(e) => setEditedName(e.target.value)}
//                         autoFocus
//                       />
//                       <MdCheck className="confirm-btn" onClick={UpdateProfile} />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="container mt-4">
//             {/* --- COLOURED STAT BOXES --- */}
//             <div className="row no-gutters mb-4">
//               <div className="col-6 p-2">
//                 <div className="stat-box blue-box">
//                   <div className="stat-header">
//                     <FaGamepad className="stat-icon" />
//                     <span>Battles</span>
//                   </div>
//                   <h2 className="stat-number">{total || 0}</h2>
//                 </div>
//               </div>
//               <div className="col-6 p-2">
//                 <div className="stat-box gold-box">
//                   <div className="stat-header">
//                     <FaTrophy className="stat-icon" />
//                     <span>Winnings</span>
//                   </div>
//                   <h2 className="stat-number">₹{profile?.wonAmount || 0}</h2>
//                 </div>
//               </div>
//             </div>

//             {/* --- ACCOUNT DETAILS SECTION --- */}
//             <div className="section-title">
//               <FiShield className="mr-2" /> Security & Settings
//             </div>

//             <div className="classic-list-container">
//               <div className="classic-item">
//                 <div className="icon-bg-blue"><FiPhone /></div>
//                 <div className="item-info">
//                   <label>Mobile</label>
//                   <span>{profile?.Phone || 'N/A'}</span>
//                 </div>
//                 <div className="verify-tag"><MdVerifiedUser /> Verified</div>
//               </div>

//               <div className="classic-item">
//                 <div className="icon-bg-green"><FiMail /></div>
//                 <div className="item-info">
//                   <label>Email</label>
//                   <span>{profile?.Email || 'Link Email'}</span>
//                 </div>
//                 <MdOutlineChevronRight size={22} className="text-muted" />
//               </div>
//             </div>

//             {/* KYC BANNER - CLASSIC STYLE */}
//             <div onClick={() => history.push("/Kyc2")} className="classic-kyc-banner mt-4">
//               <div className="d-flex align-items-center">
//                 <div className="kyc-icon-circle"><FiBriefcase /></div>
//                 <div>
//                   <h6 className="mb-0 font-weight-bold">KYC Verification</h6>
//                   <p className="mb-0 small opacity-7">Secure your account for withdrawals</p>
//                 </div>
//               </div>
//               <div className="kyc-action-btn">Verify Now</div>
//             </div>

//             {/* LOGOUT */}
//             <div className="text-center mt-5">
//               <button onClick={logout} className="classic-logout-btn">
//                 <FiLogOut className="mr-2" /> LOG OUT
//               </button>
//               <p className="build-text">Build 3.0.1 • 100% Secure Transaction</p>
//             </div>

//           </div>
//         </div>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>

//       <style>{`
//         /* --- CLASSIC PREMIUM CSS --- */
//         .classic-profile-card {
//           background: #FFFFFF;
//           border-radius: 24px;
//           padding: 30px 15px;
//           position: relative;
//           border: 1px solid #E2E8F0;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.03);
//           overflow: hidden;
//         }

//         .card-pattern {
//           position: absolute; top: 0; left: 0; width: 100%; height: 6px;
//           background: linear-gradient(90deg, #3B82F6, #F59E0B, #10B981);
//         }

//         .vip-badge {
//           background: #FEF3C7; color: #D97706; font-size: 10px;
//           font-weight: 800; padding: 4px 10px; border-radius: 50px;
//           text-transform: uppercase; display: flex; align-items: center;
//         }

//         .avatar-frame {
//           position: relative; width: 100px; height: 100px;
//           padding: 4px; border: 2px dashed #CBD5E1; border-radius: 50%;
//         }

//         .avatar-img-classic {
//           width: 100%; height: 100%; border-radius: 50%;
//           object-fit: cover; background: #F1F5F9;
//         }

//         .classic-crown {
//           position: absolute; top: -14px; left: 50%; transform: translateX(-50%);
//           color: #F59E0B; font-size: 22px; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
//           animation: float 3s ease-in-out infinite;
//         }

//         .edit-badge-classic {
//           position: absolute; bottom: 0; right: 0;
//           background: #1E293B; color: #fff; width: 28px; height: 28px;
//           border-radius: 50%; display: flex; align-items: center; justify-content: center;
//           border: 2px solid #fff; font-size: 12px;
//         }

//         .classic-name {
//           color: #1E293B; font-weight: 800; font-size: 20px;
//           margin-bottom: 2px;
//         }

//         .edit-pen { color: #94A3B8; cursor: pointer; transition: 0.2s; }
//         .edit-pen:hover { color: #3B82F6; }

//         .classic-uid { color: #64748B; font-size: 12px; font-weight: 600; }

//         /* Colored Stat Boxes */
//         .stat-box {
//           border-radius: 20px; padding: 20px 15px; border: 1px solid transparent;
//           transition: 0.3s;
//         }
//         .blue-box { background: #F0F9FF; border-color: #BAE6FD; }
//         .gold-box { background: #FFFBEB; border-color: #FEF3C7; }

//         .stat-header {
//           display: flex; align-items: center; gap: 8px; color: #64748B;
//           font-size: 11px; font-weight: 800; text-transform: uppercase; margin-bottom: 8px;
//         }
//         .stat-icon { font-size: 14px; }
//         .blue-box .stat-icon { color: #0284C7; }
//         .gold-box .stat-icon { color: #D97706; }

//         .stat-number { margin: 0; font-weight: 900; color: #1E293B; }

//         /* List Items */
//         .section-title {
//           font-size: 13px; font-weight: 800; color: #475569;
//           margin: 10px 0 15px 5px; display: flex; align-items: center;
//         }

//         .classic-list-container {
//           background: #FFFFFF; border: 1px solid #E2E8F0; border-radius: 20px;
//           overflow: hidden;
//         }
//         .classic-item {
//           padding: 15px 20px; display: flex; align-items: center; gap: 15px;
//           border-bottom: 1px solid #F1F5F9; transition: 0.2s;
//         }
//         .classic-item:last-child { border-bottom: none; }
//         .classic-item:active { background: #F8FAFC; }

//         .icon-bg-blue { background: #E0F2FE; color: #0284C7; width: 38px; height: 38px; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
//         .icon-bg-green { background: #DCFCE7; color: #16A34A; width: 38px; height: 38px; border-radius: 10px; display: flex; align-items: center; justify-content: center; }

//         .item-info label { display: block; margin: 0; font-size: 10px; color: #94A3B8; font-weight: 700; text-transform: uppercase; }
//         .item-info span { color: #1E293B; font-weight: 700; font-size: 14px; }

//         .verify-tag { margin-left: auto; color: #10B981; font-size: 11px; font-weight: 800; display: flex; align-items: center; gap: 3px; }

//         /* KYC Banner */
//         .classic-kyc-banner {
//           background: #1E293B; border-radius: 20px; padding: 18px;
//           color: #fff; display: flex; align-items: center; justify-content: space-between;
//           box-shadow: 0 8px 20px rgba(30, 41, 59, 0.15); cursor: pointer;
//         }
//         .kyc-icon-circle {
//           background: rgba(255,255,255,0.1); width: 40px; height: 40px; border-radius: 12px;
//           display: flex; align-items: center; justify-content: center; margin-right: 12px; font-size: 18px;
//         }
//         .kyc-action-btn {
//           background: #F59E0B; color: #fff; padding: 6px 14px; border-radius: 10px;
//           font-size: 11px; font-weight: 800;
//         }

//         /* Logout */
//         .classic-logout-btn {
//           background: transparent; border: 2px solid #EF4444; color: #EF4444;
//           padding: 12px 35px; border-radius: 50px; font-weight: 800; font-size: 14px;
//           transition: 0.3s;
//         }
//         .classic-logout-btn:active { background: #EF4444; color: #fff; transform: scale(0.96); }

//         .build-text { font-size: 10px; color: #94A3B8; margin-top: 15px; font-weight: 600; }

//         @keyframes float {
//           0% { transform: translateX(-50%) translateY(0); }
//           50% { transform: translateX(-50%) translateY(-6px); }
//           100% { transform: translateX(-50%) translateY(0); }
//         }

//         .cursor-pointer { cursor: pointer; }
//       `}</style>
//     </>
//   );
// };

// export default Profile1;


import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import {
  MdOutlineModeEdit,
  MdCheck,
  MdVerifiedUser,
  MdOutlineChevronRight,
  MdCameraAlt,
} from "react-icons/md";

import {
  FiPhone,
  FiMail,
  FiLogOut,
  FiShield,
  FiSettings,
  FiBriefcase,
} from "react-icons/fi";

import {
  FaTrophy,
  FaGamepad,
  FaCrown,
  FaStar,
} from "react-icons/fa";

// Components & Socket
import socket from "../Components/socket";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";

// import "./Profile1.css";


const Profile1 = () => {

  const [profile, setProfile] = useState();
  const [total, setTotal] = useState(0);
  const [isNameEdit, setIsNameEdit] = useState(false);
  const [editedName, setEditedName] = useState("");

  const history = useHistory();


  // ==========================================
  // TOTAL GAMES
  // FUNCTIONALITY SAME
  // ==========================================

  const TotalGame = (Id) => {

    let access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    axios
      .get(
        `https://api.kakaking.in/total/user/all/${Id}`,
        { headers }
      )
      .then((res) => {
        setTotal(res.data);
      })
      .catch((e) => console.error(e));

  };


  // ==========================================
  // PROFILE NAME SYNC
  // FUNCTIONALITY SAME
  // ==========================================

  useEffect(() => {

    if (profile?.Name) {
      setEditedName(profile.Name);
    }

  }, [profile]);


  // ==========================================
  // GET USER PROFILE
  // FUNCTIONALITY SAME
  // ==========================================

  const UserALL = () => {

    let access_token =
      localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    axios
      .get(
        `https://api.kakaking.in/me`,
        { headers }
      )
      .then((res) => {

        setProfile(res.data);

        TotalGame(res.data._id);

      })
      .catch((e) =>
        console.error(e)
      );

  };


  // ==========================================
  // SOCKET PROFILE
  // FUNCTIONALITY SAME
  // ==========================================

  useEffect(() => {

    socket.on("setProfile", (data) => {

      setProfile(data);

      TotalGame(data._id);

    });

    UserALL();

  }, []);


  // ==========================================
  // LOGOUT
  // FUNCTIONALITY SAME
  // ==========================================

  const logout = () => {

    let access_token =
      localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    axios
      .post(
        `https://api.kakaking.in/logout`,
        {},
        { headers }
      )
      .then(() => {

        localStorage.removeItem("token");

        history.push("/login");

        window.location.reload(true);

      });

  };


  // ==========================================
  // AVATAR UPLOAD
  // FUNCTIONALITY SAME
  // ==========================================

  const handleAvatarUpload = async (file) => {

    if (file) {

      const access_token =
        localStorage.getItem("token");

      const formData = new FormData();

      formData.append(
        "avatar",
        file
      );

      await fetch(
        `https://api.kakaking.in/users/me/avatar`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization:
              `Bearer ${access_token}`,
          },
        }
      );

      UserALL();

    }

  };


  // ==========================================
  // UPDATE PROFILE NAME
  // FUNCTIONALITY SAME
  // ==========================================

  const UpdateProfile = async () => {

    if (!editedName.trim()) {

      Swal.fire(
        "Error",
        "Name cannot be empty",
        "error"
      );

      return;

    }

    try {

      const token =
        localStorage.getItem("token");

      const res = await axios.patch(
        "https://api.kakaking.in/user/edit",
        {
          Name: editedName.trim(),
        },
        {
          headers: {
            Authorization:
              `Bearer ${token}`,
          },
        }
      );


      if (
        res.data ===
        "User name already exist!"
      ) {

        Swal.fire(
          "Error",
          res.data,
          "error"
        );

        return;

      }


      setProfile((prev) => ({
        ...prev,
        Name: res.data.Name,
      }));


      setIsNameEdit(false);


      Swal.fire({
        icon: "success",
        title: "Updated",
        timer: 1200,
        showConfirmButton: false,
      });

    } catch {

      Swal.fire(
        "Error",
        "Update failed",
        "error"
      );

    }

  };


  return (
    <>

      {/* ======================================
          HEADER
      ====================================== */}

      <Header user={profile} />


      {/* ======================================
          MAIN PAGE
      ====================================== */}

      <div className="profile-page">

        {/* 3D BACKGROUND */}

        <div className="profile-orb profile-orb-1"></div>

        <div className="profile-orb profile-orb-2"></div>

        <div className="profile-orb profile-orb-3"></div>

        <div className="profile-grid"></div>


        {/* ====================================
            PAGE LAYOUT
        ==================================== */}

        <div className="profile-layout">


          {/* ==================================
              MAIN PROFILE CONTENT
          ================================== */}

          <main className="profile-main">


            {/* =================================
                PROFILE HERO
            ================================= */}

            <section className="profile-hero-card">


              {/* Animated border */}

              <div className="profile-hero-border"></div>


              {/* Top Header */}

              <div className="profile-topbar">

                <div className="elite-badge">

                  <FaStar />

                  <span>
                    ELITE PLAYER
                  </span>

                </div>


                <div className="profile-settings">

                  <FiSettings />

                </div>

              </div>


              {/* Profile Center */}

              <div className="profile-center">


                {/* Avatar */}

                <div className="profile-avatar-wrapper">

                  <div className="avatar-glow"></div>


                  <div className="avatar-frame">

                    <FaCrown className="profile-crown" />


                    <label className="avatar-upload-label">

                      <img
                        src="/images/avatars/Avatar1.png"
                        alt="Profile"
                        className="profile-avatar"
                      />


                      <div className="avatar-edit">

                        <MdCameraAlt />

                      </div>


                      <input
                        type="file"
                        className="profile-file-input"
                        accept="image/*"
                        onChange={(e) =>
                          handleAvatarUpload(
                            e.target.files[0]
                          )
                        }
                      />

                    </label>

                  </div>

                </div>


                {/* Name */}

                <div className="profile-name-area">


                  {!isNameEdit ? (

                    <div className="profile-name-row">

                      <h1 className="profile-name">

                        {profile?.Name ||
                          "Player"}

                      </h1>


                      <button
                        type="button"
                        className="name-edit-button"
                        onClick={() =>
                          setIsNameEdit(true)
                        }
                      >

                        <MdOutlineModeEdit />

                      </button>

                    </div>

                  ) : (

                    <div className="name-edit-box">

                      <input
                        value={editedName}
                        onChange={(e) =>
                          setEditedName(
                            e.target.value
                          )
                        }
                        autoFocus
                      />


                      <button
                        type="button"
                        className="name-confirm-button"
                        onClick={UpdateProfile}
                      >

                        <MdCheck />

                      </button>

                    </div>

                  )}


                  <span className="profile-role">
                    KAKAKING PLAYER
                  </span>

                </div>

              </div>


              {/* Hero Bottom */}

              <div className="profile-secure-strip">

                <div className="secure-strip-item">

                  <MdVerifiedUser />

                  <span>
                    Verified Account
                  </span>

                </div>


                <div className="secure-strip-dot"></div>


                <div className="secure-strip-item">

                  <FiShield />

                  <span>
                    Secure Profile
                  </span>

                </div>

              </div>

            </section>


            {/* =================================
                STATISTICS
            ================================= */}

            <section className="profile-stats">


              {/* Battles */}

              <div className="profile-stat-card battles-stat">

                <div className="stat-card-top">

                  <div className="stat-icon-wrapper">

                    <FaGamepad />

                  </div>

                  <span>
                    TOTAL BATTLES
                  </span>

                </div>


                <div className="stat-value">

                  {total || 0}

                </div>


                <div className="stat-bottom">

                  <span>
                    Games Played
                  </span>

                  <FaGamepad />

                </div>

              </div>


              {/* Winnings */}

              <div className="profile-stat-card winnings-stat">

                <div className="stat-card-top">

                  <div className="stat-icon-wrapper">

                    <FaTrophy />

                  </div>

                  <span>
                    TOTAL WINNINGS
                  </span>

                </div>


                <div className="stat-value">

                  ₹{profile?.wonAmount || 0}

                </div>


                <div className="stat-bottom">

                  <span>
                    Winning Amount
                  </span>

                  <FaTrophy />

                </div>

              </div>

            </section>


            {/* =================================
                SECURITY HEADER
            ================================= */}

            <div className="profile-section-heading">

              <div className="section-heading-icon">

                <FiShield />

              </div>


              <div>

                <span>
                  ACCOUNT
                </span>

                <h2>
                  Security & Settings
                </h2>

              </div>


              <div className="section-heading-line"></div>

            </div>


            {/* =================================
                ACCOUNT DETAILS
            ================================= */}

            <section className="account-card">


              {/* Mobile */}

              <div className="account-item">

                <div className="account-icon phone-icon">

                  <FiPhone />

                </div>


                <div className="account-info">

                  <label>
                    MOBILE NUMBER
                  </label>

                  <strong>
                    {profile?.Phone ||
                      "N/A"}
                  </strong>

                </div>


                <div className="verified-badge">

                  <MdVerifiedUser />

                  <span>
                    VERIFIED
                  </span>

                </div>

              </div>


              {/* Email */}

              <div className="account-item">

                <div className="account-icon email-icon">

                  <FiMail />

                </div>


                <div className="account-info">

                  <label>
                    EMAIL ADDRESS
                  </label>

                  <strong>
                    {profile?.Email ||
                      "Link Email"}
                  </strong>

                </div>


                <MdOutlineChevronRight
                  className="account-arrow"
                />

              </div>


            </section>


            {/* =================================
                KYC CARD
            ================================= */}

            <section
              className="profile-kyc-card"
              onClick={() =>
                history.push("/Kyc2")
              }
            >


              <div className="kyc-left">

                <div className="kyc-icon">

                  <FiBriefcase />

                </div>


                <div className="kyc-content">

                  <span>
                    ACCOUNT VERIFICATION
                  </span>

                  <h3>
                    KYC Verification
                  </h3>

                  <p>
                    Secure your account for
                    withdrawals
                  </p>

                </div>

              </div>


              <div className="kyc-button">

                <span>
                  Verify Now
                </span>

                <MdOutlineChevronRight />

              </div>

            </section>


            {/* =================================
                LOGOUT
            ================================= */}

            <div className="profile-logout-area">

              <button
                type="button"
                onClick={logout}
                className="profile-logout-button"
              >

                <FiLogOut />

                <span>
                  LOG OUT
                </span>

              </button>


              <p className="profile-build-text">

                Build 3.0.1
                <span>•</span>
                100% Secure Transaction

              </p>

            </div>


          </main>


          {/* ==================================
              RIGHT SIDEBAR
          ================================== */}

          <aside className="profile-sidebar">

            <div className="profile-sidebar-sticky">

              <Rightcontainer />

            </div>

          </aside>


        </div>

      </div>

    </>
  );
};


export default Profile1;